(() => {
  const config = window.papatyaPreorder;
  if (!config || window.papatyaPreorderBound) return;
  window.papatyaPreorderBound = true;
  const protectedVariants = new Set(config.variants.map(String));
  const memberAt = Date.parse('2026-09-25T20:00:00+01:00');
  const publicAt = Date.parse('2026-09-26T20:00:00+01:00');
  let member = config.member === true;
  let checking = config.store === 'kbn' && config.loggedIn;
  let dialog;
  let previousFocus;
  function allowed(now = Date.now()) { return now >= publicAt || (now >= memberAt && member && !checking); }
  function message() {
    if (checking) return 'We’re checking your membership. Please try again in a moment. Members can order or add to Trove from 8pm today, Friday 25 September. Everyone else can order from 8pm tomorrow, Saturday 26 September (UK time).';
    if (member) return 'You cannot order this item or add it to your Trove yet. Member access opens at 8pm today, Friday 25 September (UK time).';
    return 'You cannot order this item or add it to your Trove yet. Non-member access opens at 8pm tomorrow, Saturday 26 September (UK time). Members can order from 8pm today. Please sign in if you are a member.';
  }
  function show() {
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'papatya-preorder-dialog';
      dialog.setAttribute('aria-labelledby', 'papatya-preorder-title');
      dialog.innerHTML = '<h2 id="papatya-preorder-title">Preorders open soon</h2><p data-preorder-message></p><div><a href="/account/login">Sign in</a><button type="button">Got it</button></div>';
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => previousFocus?.focus());
      document.body.append(dialog);
    }
    dialog.querySelector('[data-preorder-message]').textContent = message();
    dialog.querySelector('a').hidden = config.loggedIn;
    if (!dialog.open) { previousFocus = document.activeElement; dialog.showModal(); }
  }
  function refresh() {
    document.documentElement.classList.toggle('papatya-preorder-locked', config.productProtected && !allowed());
    if (dialog?.open) {
      if (allowed()) dialog.close();
      else dialog.querySelector('[data-preorder-message]').textContent = message();
    }
  }
  function formVariant(form) {
    if (!form) return '';
    return String(form.querySelector('[name="id"]:checked')?.value || form.querySelector('[name="id"]')?.value || '');
  }
  function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); show(); }
  window.addEventListener('click', event => {
    if (allowed() || !(event.target instanceof Element)) return;
    const button = event.target.closest('button,input[type="submit"],a');
    if (!button || button.closest('.papatya-preorder-dialog')) return;
    const form = button.form || button.closest('form');
    const isAdd = form && /\/cart\/add(?:\.js)?(?:\?|$)/.test(new URL(form.action, location.origin).pathname);
    const trove = button.matches('.trove-add-button,[data-sticky-trove-button],[data-kbn-trove-button]');
    const isCheckout = button.matches('[name="checkout"],a[href^="/checkout"]');
    let variant = formVariant(form);
    if (trove) {
      const scope = button.closest('product-info,product-rerender,.shopify-section');
      variant = formVariant(scope?.querySelector('form[action*="/cart/add"]')) || button.closest('[data-default-variant-id]')?.dataset.defaultVariantId || String(config.currentVariant || '');
    }
    if (((isAdd || trove) && protectedVariants.has(variant)) || (isCheckout && config.cartVariants.some(id => protectedVariants.has(String(id))))) stop(event);
  }, true);
  window.addEventListener('submit', event => {
    if (allowed() || !(event.target instanceof HTMLFormElement)) return;
    const form = event.target;
    if ((/\/cart\/add/.test(form.action) && protectedVariants.has(formVariant(form))) || (event.submitter?.name === 'checkout' && config.cartVariants.some(id => protectedVariants.has(String(id))))) stop(event);
  }, true);
  async function checkMembership() {
    if (config.store !== 'kbn' || !config.loggedIn || Date.now() >= publicAt) return;
    checking = true; refresh();
    try {
      const response = await fetch('/apps/knotty-community/preorder-access', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(10000)});
      const data = response.ok ? await response.json() : {};
      member = data.eligible === true;
    } catch { member = false; }
    checking = false; refresh();
  }
  refresh();
  document.addEventListener('DOMContentLoaded', refresh);
  window.addEventListener('pageshow', () => { refresh(); void checkMembership(); });
  setInterval(refresh, 1000);
  if (config.store === 'kbn' && config.loggedIn) setInterval(checkMembership, 60000);
})();
